import { useCallback, useMemo } from 'react'
import { useGetCurrencyGlobalLimits } from 'hooks/queries/useGetCurrencyGlobalLimits'

export const usePaymentMethodLimits = (currency?: string) => {
  const { data, isError } = useGetCurrencyGlobalLimits(currency)

  const limitByMethod = useMemo(
    () => (isError ? {} : (data?.limits ?? {})),
    [data?.limits, isError]
  )

  const isMethodDisabledForAmount = useCallback(
    (method: string, amount?: string | number) => {
      const limit = limitByMethod[method]
      if (limit === undefined) return false
      return Number(amount) > limit
    },
    [limitByMethod]
  )

  return { limitByMethod, isMethodDisabledForAmount }
}
